<script setup>
import { Link } from '@inertiajs/vue3'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'
import { CheckCircleIcon } from '@heroicons/vue/24/solid'
import AboutController from '@/actions/App/Http/Controllers/AboutController'

const benefits = [
    'Více než 30 let zkušeností v oboru',
    'Profesionální tým kvalifikovaných techniků',
    'Havarijní služba dostupná 24/7',
    'Férové ceny bez skrytých poplatků',
    'Záruka na veškerou provedenou práci',
    'Osobní přístup ke každému zákazníkovi',
]
</script>

<template>
    <section class="bg-gray-900 px-2 lg:px-0">
        <div class="section-width grid grid-cols-1 items-center gap-16 lg:grid-cols-2">
            <div class="relative">
                <div class="aspect-4/3 overflow-hidden rounded-2xl">
                    <img
                        src="/images/o-nas-firma.webp"
                        alt="Tým Kalianko - profesionální instalatéři"
                        class="size-full object-cover"
                    />
                </div>
            </div>

            <div>
                <p class="text-brand-primary text-sm font-semibold tracking-wider uppercase">O naší firmě</p>
                <h2 class="heading-2 mt-2 text-white">Jsme rodinná firma s tradicí a osobním přístupem</h2>
                <p class="paragraph mt-4 text-gray-300">
                    Na trhu působíme od roku 1995. Dbáme na dobrou pověst firmy a odvádíme svou práci tak, aby byli
                    spokojeni jak naši zákazníci, tak my. Služby poskytujeme včetně profesionálního poradenství ohledně
                    technického řešení, výběru, nákupu technologie a zařizovacích předmětů. Od roku 2011 se
                    specializujeme na maloobchodní prodej instalaterskeho materiálu.
                </p>

                <ul class="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
                    <li
                        v-for="benefit in benefits"
                        :key="benefit"
                        class="flex items-start gap-3"
                    >
                        <CheckCircleIcon class="text-brand-primary mt-0.5 size-5 shrink-0" />
                        <span class="text-sm text-gray-400">{{ benefit }}</span>
                    </li>
                </ul>

                <div class="mt-10">
                    <Link
                        :href="AboutController()"
                        class="inline-flex w-full items-center justify-center rounded-full border border-white/30 bg-white/10 px-6 py-3 font-semibold text-white backdrop-blur-lg transition hover:bg-white/20 sm:w-auto"
                        aria-label="Více o nás"
                    >
                        Zjistit více o naší firmě
                        <ArrowRightIcon class="ml-2 size-4" />
                    </Link>
                </div>
            </div>
        </div>
    </section>
</template>
